import { TradeValidity } from "@models/trading/TradeValidity";

class TradeValidatiesTableController {
  public trades: TradeValidity[]
  public showTicker: boolean;

  public formatPortfolios(portfolios: string[]) {
    return `Affect Portfolios:
    ${portfolios.map(p => `- ${p}`).join('\n')}`
  }
}

export const TradeValidatiesTable: angular.IComponentOptions = {
  controller: TradeValidatiesTableController,
  template: require('./tradeValidatiesTable.component.html'),
  bindings: {
    trades: '<',
    showTicker: '<'
  }
}



// WEBPACK FOOTER //
// ./src/app/trading/portfoliotradesets/tradeValidatiesTable.component.ts